import React, { createContext, useReducer, useContext } from 'react';
import { ACTIONS } from 'constants';

const GlobalBannerStateContext = createContext();
const GlobalBannerDispatchContext = createContext();

const initialState = { message: '', type: 'None', show: false };

const GlobalBannerReducer = (state, action) => {
	const { message, type, show } = action.payload;
	switch (action.type) {
		case ACTIONS.GLOBAL_BANNER_SHOW:
			return { ...state, message, type, show };
		default:
			return state;
	}
};

const GlobalBannerProvider = (props) => {
	const [state, dispatch] = useReducer(GlobalBannerReducer, initialState);
	return (
		<GlobalBannerStateContext.Provider value={{ state }}>
			<GlobalBannerDispatchContext.Provider value={{ dispatch }}>
				{props.children}
			</GlobalBannerDispatchContext.Provider>
		</GlobalBannerStateContext.Provider>
	);
};

const useGlobalBannerStateContext = () => {
	const { state } = useContext(GlobalBannerStateContext);

	return state;
};

const useGlobalBannerDispatchContext = () => {
	const { dispatch } = useContext(GlobalBannerDispatchContext);

	return dispatch;
};

export {
	GlobalBannerProvider,
	useGlobalBannerStateContext,
	useGlobalBannerDispatchContext,
	GlobalBannerReducer
};
